import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FrameListService } from "../../../inside-survey/services/frameList.service";

@Component({
  selector: "app-survey-frame-list-template",
  templateUrl: "./survey-frame-list-template.component.html",
  styleUrls: ["./survey-frame-list-template.component.scss"],
})
export class SurveyFrameListTemplateComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() index: number;
  @Input() noClick: boolean = false;
  toggled: boolean = false;

  constructor(private frameListService: FrameListService) {}
  destroy$ = new Subject();
  ngOnDestroy(): void {
    this.frameListService.toggleEvent.next([]);
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  ngOnInit() {
    if (!this.id) this.id = this.constructor.name + this.index;

    this.frameListService
      .onToggle()
      .pipe(takeUntil(this.destroy$))
      .subscribe((list) => {
        if (this.noClick) return;
        this.toggled = list.includes(this.id);
      });

    this.toggled = this.noClick
      ? false
      : this.frameListService.toggleEvent.value.includes(this.id);
  }

  onToggleDetail() {
    this.frameListService.toggle(this.id);
  }
}
